import { Plugin, PluginKey } from "prosemirror-state";
import type { EditorView } from "prosemirror-view";

export interface LinkToolbarState {
  /** True while the href field should be focused (link just created). */
  editing: boolean;
}

export const linkToolbarKey = new PluginKey<LinkToolbarState>("wikiLinkToolbar");

const OPEN = "open";
const CLOSE = "close";

/**
 * `Mod-K` creates the mark and asks for the href afterwards (`editor.md` §4),
 * so "the toolbar is in edit mode" is editor state, not component state: any
 * selection change ends it.
 */
export function linkToolbarPlugin(): Plugin<LinkToolbarState> {
  return new Plugin<LinkToolbarState>({
    key: linkToolbarKey,
    state: {
      init: () => ({ editing: false }),
      apply(tr, value) {
        const meta = tr.getMeta(linkToolbarKey) as string | undefined;
        if (meta === OPEN) return { editing: true };
        if (meta === CLOSE) return { editing: false };
        if (value.editing && tr.selectionSet) return { editing: false };
        return value;
      },
    },
  });
}

export function openLinkToolbar(view: EditorView): void {
  view.dispatch(view.state.tr.setMeta(linkToolbarKey, OPEN));
}

export function closeLinkToolbar(view: EditorView): void {
  view.dispatch(view.state.tr.setMeta(linkToolbarKey, CLOSE));
}

export function isLinkToolbarEditing(
  state: Parameters<typeof linkToolbarKey.getState>[0],
): boolean {
  return linkToolbarKey.getState(state)?.editing ?? false;
}
